var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09 12.59 8.5 14l5-5-5-5-1.41 1.41L9.67 8H0v2h9.67l-2.58 2.59ZM16 0H2a2 2 0 0 0-2 2v4h2V2h14v14H2v-4H0v4a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2Z",
    fill: "#AEAEAE"
  })));
};
export { SvgLogout as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMDkgMTIuNTlMOC41IDE0TDEzLjUgOUw4LjUgNEw3LjA5IDUuNDFMOS42NyA4SDBWMTBIOS42N0w3LjA5IDEyLjU5Wk0xNiAwSDJDMC44OSAwIDAgMC45IDAgMlY2SDJWMkgxNlYxNkgyVjEySDBWMTZDMCAxNy4xIDAuODkgMTggMiAxOEgxNkMxNy4xIDE4IDE4IDE3LjEgMTggMTZWMkMxOCAwLjkgMTcuMSAwIDE2IDBaIiBmaWxsPSIjQUVBRUFFIi8+Cjwvc3ZnPgo=";